import React, { useState } from "react";
import fbicon from "../../images/Group.svg";
import twit from "../../images/Group-2.svg";
import instaicon from "../../images/Group 30.svg";
import linkedin from "../../images/footer_linkedin.svg";
import phoneicon from "../../images/phoneicon.svg";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const [emailInput, setEmailInput] = useState();

  const [formConfirm, setFormConfirm] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("/newsletter", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: emailInput }),
    })
      .then((res) => res.json())
      .then((res) => setFormConfirm(res));
  };

  return (
    <div className="container footer_container">
      {/* <a
        href="https://wa.me/916201811075"
        class="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fa fa-whatsapp whatsapp-icon"></i>
      </a> */}

      <div className="footer_newsletter">
        <p className="footer_subscribe">Subscribe to Our Newsletter</p>

        <p className="footer_subscribe_text">
          Get all your queries general queries solved regarding Event Management
          and about us and our services.
        </p>

        <div className="footer_input_cont">
          {formConfirm ? (
            <div>
              <p style={{ color: "#fff", fontSize: "20px" }}>
                Email Address recieved, Thank You!
              </p>
            </div>
          ) : (
            <form className="footer_input_cont" onSubmit={handleSubmit}>
              <input
                type="email"
                className="footer_email"
                placeholder="Enter Your Email"
                value={emailInput}
                required
                onChange={(e) => setEmailInput(e.target.value)}
              />

              <button type="submit" className="footer_submit">
                Submit
              </button>
            </form>
          )}
        </div>

        <div className="footer_social">
          <p className="footer_follow">FOLLOW US</p>

          <div className="footer_social_icons">
            <a href="https://www.facebook.com/info.skylarkevents/">
              <img className="socail_icon" src={fbicon} />
            </a>
            <a href="https://instagram.com/skylark.events_decor?igshid=YmMyMTA2M2Y=">
              <img className="socail_icon" src={instaicon} />
            </a>
            <a href="https://www.linkedin.com/company/skylark-events-decor/">
              <img className="socail_icon" src={linkedin} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer_navitems">
        <Link style={{ textDecoration: "none" }} to={"/"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="footer_nav_item home_item"
            style={{ margin: "0" }}
          >
            Home
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/faqs"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="footer_nav_item"
          >
            FAQs
          </p>
        </Link>

        <Link style={{ textDecoration: "none" }} to={"/blogs"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="footer_nav_item"
          >
            Blogs
          </p>
        </Link>

        <a href="/#gallery">
          <p className="footer_nav_item">Gallery</p>
        </a>

        <Link style={{ textDecoration: "none" }} to={"/contactus"}>
          <p
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="footer_nav_item"
          >
            Contact Us
          </p>
        </Link>
      </div>

      <div className="footer_address">
        <p
          style={{ margin: "0" }}
          className="footer_address_text footer_address_heading"
        >
          Head office:{" "}
        </p>
        <p style={{ marginTop: "15px" }} className="footer_address_text">
          {" "}
          BF 44, Shantipally, Rajdanga Main Road, Kolkata, 700107
        </p>

        <div className="footer_phone_num">
          <img src={phoneicon} />
          <p className="phoneNumber">6201811075</p>
        </div>
      </div>
    </div>
  );
}
